import { SET_URL, INIT_APP } from '../constants/types';
import { updateUrl } from '../lib/UrlUtils';

export const setUrl = url => {
  updateUrl(url);

  return {
    type: SET_URL,
    url,
  };
};

export const initApp = app => {
  return {
    type: INIT_APP,
    app,
  };
};
